import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { IssueId, MentionsResponse } from './types';

export function mentionsService(issueIds: IssueId[]): ObservableType<MentionsResponse[]> {
	return fetchJson$('/rest/internal/latest/mentions', {
		method: 'POST',
		body: JSON.stringify(issueIds),
	});
}
